import { motion } from 'motion/react'
import { Button } from '../Button'

const MenuItemVariants = {
  hidden: {
    opacity: 0,
  },
  visible: {
    x: 0,
    opacity: 1,
  },
}

export const MenuItem = ({ label, href }) => {
  return (
    <motion.li
      className="my-2 block w-full"
      variants={MenuItemVariants}
      layout="position"
      initial="hidden"
      animate="visible"
      exit="hidden"
      transition={{
        duration: 0.1,
        ease: 'easeInOut',
      }}
    >
      <Button layout href={href} className="w-full">
        {label}
      </Button>
    </motion.li>
  )
}
